









import { computed, defineComponent } from '@vue/composition-api';
import { formatPhoneNumber } from '@front-app/util/format';

export default defineComponent({
	props: {
		phone: {
			type: String,
			required: true,
		},
		extension: {
			type: String,
			default: '',
		},
	},
	setup(props) {
		const phoneHref = computed(() => {
			if (props.extension) {
				return `tel:${props.phone};${props.extension}`;
			}
			return `tel:${props.phone}`;
		});
		return {
			phoneHref,
			formatPhoneNumber,
		};
	},
});
